import script from "./ExamTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamTable.vue?vue&type=script&setup=true&lang=js"

import "./ExamTable.vue?vue&type=style&index=0&id=478e3e8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478e3e8b"]])

export default __exports__